import { Inject, Component, ChangeDetectionStrategy } from '@angular/core';

import { ISnPlayer } from '../../interfaces';

@Component({
  selector: 'sn-player-progress-bar-control',
  templateUrl: './player-progress-bar.control.html',
  styleUrls: ['./player-progress-bar.control.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnPlayerProgressBarControl {
  constructor(@Inject('SN_PLAYER') public player: ISnPlayer) {}
}
